import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const styleVariants = {
  sm: 'container mx-auto relative xl:max-w-[60.625rem] sm:px-0 px-6 md:px-4 2xl:px-0',
  default: 'container mx-auto relative xl:max-w-[73.125rem] xl:px-0 px-6 md:px-4 2xl:px-0',
  lg: 'container mx-auto relative xl:max-w-[98.125rem] 4xl:px-0 px-6 md:px-4 2xl:px-0',
  xl: 'container mx-auto relative xl:max-w-[107.5rem] 4xl:px-0 px-6 md:px-4 2xl:px-0',
  regular: 'container mx-auto relative xl:max-w-[1635px] 4xl:px-0 px-6 md:px-4 2xl:px-0',
};

export default function BoxedContainer({ children, className = '', variant = 'default' }) {
  
  const classnames = `${styleVariants[variant]} ${className}`;

  useEffect(() => {
    document.body.classList.add('free-zone');
    return () => {
      document.body.classList.remove('free-zone');
    };
  }, []);

  return (
  <div className={classnames}>
    {/* <Helmet bodyAttributes={{ class: 'free-zone' }} /> */}
    {children}
    </div>);
}
